import { KeyValueEntity } from './BasicEntities';

export class Coverage extends KeyValueEntity {}
